import {UnavailableProductsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/basket_sections.types';
import {useTranslation} from '@aboutyou/i18n';
import {BasketSection, DeliverySection} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {UnavailableProductItem} from './UnavailableProductItem';
import type {UnavailableProductsProps} from './UnavailableProducts';

import {isCaseTypeCheck} from '@aboutyou/utils';

export const UnavailableProductsView: FC<
  UnavailableProductsSection & UnavailableProductsProps
> = ({SizeReminderLayoutComponent, type}) => {
  const {t} = useTranslation();

  if (!isCaseTypeCheck('tiles', type) || !type.tiles.items.length) {
    return null;
  }
  const {items} = type.tiles;

  return (
    <BasketSection>
      <DeliverySection headline={t('Sold out products')} hideInfoText>
        {items.map(item => {
          return (
            <UnavailableProductItem
              key={item.itemKey}
              item={item}
              SizeReminderLayoutComponent={SizeReminderLayoutComponent}
            />
          );
        })}
      </DeliverySection>
    </BasketSection>
  );
};
